/* helper.ts */

/* Constants */
import { TableType } from "src/shared/constants/charts/Table";

/* Utils */
import {
  responseTableLabelMapping,
  treatmentTableLabelMapping,
} from "src/utils/mapper/tableLabelMapper";

export const mapKeyToTableLabelMapper = (
  key: TableType
) => {
  switch (key) {
    case TableType.TREATMENT_TABLE:
      return treatmentTableLabelMapping;
    case TableType.RESPONSE_TABLE:
      return responseTableLabelMapping;
    default:
      return responseTableLabelMapping;
  }
};
